import { isStringEmpty } from './isStringEmpty'

export const validateStringLength = (string, length) => {
  return !isStringEmpty(string) && string.length <= length
}
